import React from 'react'
import { object } from 'prop-types'
import Layout from 'layouts/Layout'
import { graphql } from 'gatsby'

import Refills from 'containers/Refills'
import MetaTags from 'components/MetaTags'

const VusePods = ({ data }) => (
  <Layout stickyHeader lightFooter>
    <MetaTags title="Vuse Pods" description="Select your device and flavours to begin subscribing" />
    <Refills
      titleOverride="Vuse Pods"
      descriptionOverride=" "
      hidePrice
      deviceHandles={['vype-epod-vpro-cartridges', 'vype-epen-3-cartridges-vpro']}
      largeHeading
      subscriptionOnly
      data={data}
    />
  </Layout>
)

VusePods.propTypes = {
  data: object.isRequired
}

export default VusePods

export const query = graphql`
  {
    cartridgeCollection: allShopifyCollection(
      filter: { handle: { in: ["vype-epod-vpro-cartridges", "vype-epen-3-cartridges-vpro"] } }
    ) {
      nodes {
        ...CartridgeCollectionFragment
      }
    }
    collectionsProducts: allShopifyCollection {
      nodes {
        id
        handle
        products {
          id
          handle
        }
      }
    }
  }
`
